import React from 'react';
const IconPersonGroup = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.23 15L10.96 13H3.3L0.75 20H8.41L9.14 18H3.61L4.7 15H10.23Z" fill="#2D2E2E"/>
<path d="M7.5 11.5C9.71 11.5 11.5 9.71 11.5 7.5C11.5 5.29 9.71 3.5 7.5 3.5C5.29 3.5 3.5 5.29 3.5 7.5C3.5 9.71 5.29 11.5 7.5 11.5ZM7.5 5.5C8.6 5.5 9.5 6.4 9.5 7.5C9.5 8.6 8.6 9.5 7.5 9.5C6.4 9.5 5.5 8.6 5.5 7.5C5.5 6.4 6.4 5.5 7.5 5.5Z" fill="#2D2E2E"/>
<path d="M17 11.5C19.21 11.5 21 9.71 21 7.5C21 5.29 19.21 3.5 17 3.5C14.79 3.5 13 5.29 13 7.5C13 9.71 14.79 11.5 17 11.5ZM17 5.5C18.1 5.5 19 6.4 19 7.5C19 8.6 18.1 9.5 17 9.5C15.9 9.5 15 8.6 15 7.5C15 6.4 15.9 5.5 17 5.5Z" fill="#2D2E2E"/>
<path d="M20.6998 13H13.1198L10.5698 20H18.9898L18.2698 18H13.4298L14.5198 15H19.2998L21.1198 20H23.2498L20.6998 13Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconPersonGroup;